import React, { Component } from "react"
import { FaChevronLeft, FaGlobe } from "react-icons/fa"
import { injectIntl } from "react-intl"
import styled from "styled-components"
import { styles } from "../globals"

class SelectLang extends Component {
  slideToggle() {
    document.querySelector(".dropdown").classList.toggle("active")
  }
  slideClose() {
    document.querySelector(".dropdown").classList.remove("active")
  }

  render() {
    const {
      intl: { locale },
    } = this.props
    const { items } = this.props
    return (
      <SelectLangWrapper>
        <div
          className="dropdown"
          onBlur={this.slideClose}
          onClick={this.slideToggle}
          tabIndex="-1"
        >
          <div className="select">
            <FaGlobe className="globe-icon" />
            <span id="show-selected">{locale}</span>
            <FaChevronLeft className="chevron-left-icon" />
          </div>
          <input id="hidden-input" type="hidden" name="language" />
          <ul className="dropdown-menu">
            {items.map((item, index) => (
              <li data-lang={item.lang} key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </SelectLangWrapper>
    )
  }
}

const SelectLangWrapper = styled.div`
  margin-left: 0.8rem;
  .chevron-left-icon {
    margin-left: 0.2rem;
    padding-top: 0.3rem;
  }
  .globe-icon {
    padding-top: 0.2rem;
    margin-right: 0.3rem;
  }
  .dropdown {
    color: ${styles.mainWhite};
    padding-left: 0.3rem;
    position: relative;
  }
  .dropdown .select {
    cursor: pointer;
    display: block;
    padding-top: 0.8rem;
  }
  .dropdown .select > i {
    color: #888;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
  }
  .dropdown:active {
    background-color: #f8f8f8;
  }

  .dropdown.active .dropdown-menu {
    height: 140px;
  }

  .dropdown.active .select .chevron-left-icon {
    transform: rotate(-90deg);
  }
  .dropdown .dropdown-menu {
    background: ${styles.darkGrey};
    position: absolute;
    width: 100%;
    height: 0;
    left: 0;
    margin: 0;
    overflow: hidden;
    ${styles.transform({ property: "height" })};
    z-index: 9;
  }
  .dropdown .dropdown-menu li {
    padding: 10px;
    cursor: pointer;
    transition: all 1s ease-in-out;
  }
  .dropdown .dropdown-menu {
    padding: 0;
    list-style: none;
  }
  .dropdown .dropdown-menu li {
    padding: 0;
  }
  .dropdown .dropdown-menu li > a {
    color: ${styles.mainWhite};
    display: inline-block;
    width: 100%;
    padding: 10px;
  }
  .dropdown .dropdown-menu li > a:hover {
    color: ${styles.mainOrange};
  }
  .dropdown .dropdown-menu li:hover {
    background-color: grey;
  }

  @media (min-width: ${styles.smallScreenBreakpoint}) {
    .globe-icon {
      margin-left: 0.3rem;
    }
    .dropdown {
      padding: 0;
      width: 5rem;
      display: inline-block;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 0 2px rgb(204, 204, 204);
      position: relative;
      color: #474747;
      height: 100%;
      text-align: left;
    }
    .dropdown .select {
      cursor: pointer;
      display: block;
    }
    .dropdown .select > i {
      color: #888;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
    }
    .dropdown:hover {
      box-shadow: 0 0 4px rgb(204, 204, 204);
    }
    .dropdown:active {
      background-color: #f8f8f8;
    }

    .dropdown.active:hover,
    .dropdown.active {
      box-shadow: 0 0 4px rgb(204, 204, 204);
      border-radius: 5px 5px 0 0;
      background-color: #f8f8f8;
    }
    .dropdown.active .select .chevron-left-icon {
      transform: rotate(-90deg);
    }
    .dropdown .dropdown-menu {
      position: absolute;
      background-color: #fff;
      width: 100%;
      height: 0;
      left: 0;
      margin: 0;
      box-shadow: 0 1px 2px rgb(204, 204, 204);
      border-radius: 0 1px 5px 5px;
      overflow: hidden;
      ${styles.transform({ property: "height" })};
      z-index: 9;
    }
    .dropdown .dropdown-menu li {
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
    }
    .dropdown .dropdown-menu {
      padding: 0;
      list-style: none;
    }
    .dropdown .dropdown-menu li {
      padding: 0;
    }
    .dropdown .dropdown-menu li > a {
      color: ${styles.mainOrange};
      display: inline-block;
      width: 100%;
      padding: 10px;
    }
    .dropdown .dropdown-menu li:hover {
      background-color: #f2f2f2;
    }
    .dropdown .dropdown-menu li:active {
      background-color: #e2e2e2;
    }
  }
`
export default injectIntl(SelectLang)
